import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa';

const EmptyStateLocale = ({ isLiveSite, locale }) => {
  const locales = {
    "calendar_widget_empty_state_previw_title": "Connect your account",
    "calendar_widget_empty_state_previw_subtitle": "To add your Google calendar to your site, go to ‘Settings’ and connect your Google account.",
    "calendar_widget_empty_state_site_title": "Check back soon",
    "calendar_widget_empty_state_site_subtitle": "There are no calendar events to show at the moment. Try again later."
  }

  const headerContent = isLiveSite
    ? locales.calendar_widget_empty_state_site_title
    : locales.calendar_widget_empty_state_previw_title;
  const textContent = isLiveSite
    ? locales.calendar_widget_empty_state_site_subtitle
    : locales.calendar_widget_empty_state_previw_subtitle;

  return (
    <div
      style={{
        border: '1px solid grey',
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px',
        textAlign: 'center',
      }}
    >
      <Text typography={TextTypography.largeTitle}>{headerContent}</Text>
      <Text>{textContent}</Text>
    </div>
  );
};

export default EmptyStateLocale;
